import { SettingsModal, SETTINGS_TABS } from "./index";
import { BillingPanel } from "./BillingPanel";

// Route element for /settings/billing.
export const BillingSettings = () => (
  <SettingsModal active={SETTINGS_TABS.BILLING}>
    <BillingPanel />
  </SettingsModal>
);
